import anime from 'animejs';
import _ from 'lodash';

export function initAnimations() {
    const logoAnimationParts = buildParts('.patchbot-logo');
    initLogoAnimation(logoAnimationParts);
    handleLogoClick(logoAnimationParts);
}

function initLogoAnimation(parts) {
    // Bail if no parts are found.
    if (_.isEmpty(parts)) {
        return;
    }
    let fadeInTL = anime.timeline();

    const shadow = anime({
        targets: parts.bodyShadow1,
        opacity: [0, 1],
        delay: 1700,
        easing: 'easeInOutSine',
    });
    const shadow2 = anime({
        targets: parts.bodyShadow2,
        opacity: [0, 1],
        delay: 1500,
        easing: 'easeInOutSine',
    });

    const faceFade = anime({
        targets: [parts.mouth, parts.rightEye, parts.leftEye],
        delay: function() { return anime.random(800, 1600); },
        opacity: [0, 1],
        easing: 'easeInOutQuart',
    });

    const starFadeIn = anime({
        targets:[parts.star1,parts.star2, parts.star3, parts.star4],
        opacity: [0, 1],
        translateY: [-50, 0],
        delay: function() { return anime.random(0, 1000); },
        duration: function() { return anime.random(800, 1600); },
        easing: 'easeInSine',
    });

    fadeInTL
        .add({
            targets: getFadedParts(parts),
            translateY: [50, 0],
            opacity: [0, 1],
            easing: 'easeInOutQuart',
            duration: 2000,
            delay: function(el, i) {
                return i * 80;
            },
        });
}

/**
 * Returns a list of parts that are initially faded in.
 * @param parts
 * @returns {Array}
 */
function getFadedParts(parts) {
    let fadeInParts = [];
    Object.keys(parts).forEach((key) => {

        switch(key) {
            case 'star1':
            case 'star2':
            case 'star3':
            case 'star4':
            case 'bodyShadow1':
            case 'bodyShadow2':
            case 'mouth':
            case 'leftEye':
            case 'rightEye':
                break;
            default:
                fadeInParts.push(parts[key]);
                break;
        }
    });
    return fadeInParts;
}

/**
 * Builds a list of parts associated with DOM node.
 * @param selector What element you wish to extract parts. ig. ".patchbot-logo" to select all children that contain an ID.
 * @returns object {partNameCamelized: '#partNameId'}
 */
function buildParts(selector) {
    if (!selector) {
        // Bail if no selector is passed.
        return;
    }
    let ids = {};
    const parts = document.querySelectorAll(`${selector} *`);
    for (let i = 0; i < parts.length; i++) {
        if (parts[i].id) {
            ids[normalizePartName(parts[i].id)] = `#${parts[i].id}`;
        }
    }

    return ids;
}

/**
 * Helper function that camelCases the part name.
 * @param str The original part name string.
 * @returns string The camelCase part name.
 */
function normalizePartName(str) {
    return str.replace(/(\_\w)/g, function(m){
        return m[1].toUpperCase();
    });
}

/**
 * Reanimate the logo when the user clicks it.
 * @param logoParts
 */
function handleLogoClick(logoParts) {
    const logoClickHandler = document.querySelector('.patchbot-logo');
    if (logoClickHandler) {
        logoClickHandler.addEventListener('click', () => {
            initLogoAnimation(logoParts);
        });
    }
}
